import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import { Values } from "@src/Tools/Values";
import AuthApplicationsContent from "./AuthApplicationsContent/AuthApplicationsContent";

interface IProps {
  management?: IManagementStore;
}

@inject("management", "values")
@observer
export default class AuthApplications extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getOAuthApplications(),
        this.props.management.getLocations(),
        this.props.management.getActiveLocations(),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("oAuthApplications");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <AuthApplicationsContent />}</div>;
  }
}
